export default {
    path: '/', component: () => import("@/pages/Cabinet/Client/App"),
    children: [
        {
            path: '/cabinet', name: 'client.cabinet', redirect: {name: 'client.cabinet.records'},
        },
        {
            path: '/cabinet/records',
            name: 'client.cabinet.records',
            component: () => import("@/pages/Cabinet/Client/Records"),
        },
        {
            path: '/cabinet/client/bonus',
            name: 'client.cabinet.bonus',
            component: () => import("@/pages/Cabinet/Client/Bonus"),
        },
        {
            path: '/cabinet/client/messages',
            name: 'client.cabinet.messages',
            component: () => import("@/pages/Cabinet/Client/Chat"),
        },
        {
            path: '/cabinet/client/notifications',
            name: 'client.cabinet.notifications',
            component: () => import("@/pages/Cabinet/Client/Notifications"),
        },
        {
            path: '/cabinet/client/settings',
            name: 'client.cabinet.settings',
            component: () => import("@/pages/Cabinet/Client/Settings/Index"),
        },
    ]
};